import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { useThemeProps, handleComponentsProp, Icon, Button } from "@wsui/base";
import { pickAll } from "lodash/fp";
import postsModuleContext from "./postsModuleContext.mjs";
import { useContext } from "react";
const DefaultButton = Button;
function PostsModuleButtonItem(props) {
  props = useThemeProps({
    props,
    name: "MunicipioPostsModuleButtonItem"
  });
  let {
    item,
    visibleFields,
    components = {},
    width,
    iconProps = {},
    ...restProps
  } = props;
  let {
    Button: Button2
  } = handleComponentsProp(components, {
    Button: DefaultButton
  });
  let link = item == null ? void 0 : item.link;
  let icon = item == null ? void 0 : item.icon;
  item = pickAll(visibleFields, item);
  const {
    itemColor
  } = useContext(postsModuleContext);
  return /* @__PURE__ */jsxs(Button2, {
    color: itemColor,
    href: link == null ? void 0 : link.url,
    width,
    variant: "shortcut",
    ...restProps,
    children: [!!icon && /* @__PURE__ */jsx(Icon, {
      name: icon,
      size: "1.5em",
      ...iconProps
    }), item.title]
  });
}
export { PostsModuleButtonItem as default };